import { Box, Spinner } from '@zillow/constellation-10';

export const PageLoading = () => {
  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'center',
        paddingInline: '400',
        paddingBlock: '800',
        width: '100%',
        height: '100%',
      }}
    >
      <Spinner size="lg" />
    </Box>
  );
};
